var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 348,
    viewBox: "0 0 449 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219 2.40014C212.867 5.46681 208.333 12.4001 208.333 18.9335C208.333 22.1335 209.933 27.3335 212.6 32.4001C214.867 36.9335 217.133 42.4001 217.533 44.6668C218.467 48.5335 218.6 48.6668 227.4 49.0668C236.067 49.4668 236.333 49.3335 236.333 46.2668C236.333 44.5335 238.467 39.0668 241 34.2668C248.467 20.2668 246.733 8.66681 236.467 2.93347C230.2 -0.666527 225.133 -0.799862 219 2.40014Z",
    fill: "url(#paint0_linear_26_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.667 62.5334C151 65.8668 140.467 74.6667 135.267 84.5334C132.6 89.8667 131.667 93.8667 131.267 102.933C130.733 113.067 131.133 115.2 133.933 121.6C137 128 177.4 179.067 185.267 186.267C189.533 190.267 198.6 190.4 203.4 186.533C207.8 183.2 210.333 175.333 208.6 170.533C207.8 168.667 197.4 155.2 185.267 140.533C173.267 125.733 162.6 112.533 161.8 110.933C158.867 105.467 159.933 98.6667 164.467 94.5334L168.6 90.6667H224.333C278.067 90.6667 280.067 90.8001 283.4 93.3334C287.933 96.9334 290.2 103.867 288.333 108.533C287.133 111.733 272.467 130 199.133 218.667C187.933 232.267 168.467 255.867 155.933 271.333C125 309.067 118.867 315.2 110.2 317.333C102.6 319.067 96.0667 317.867 88.8667 313.467C85.4001 311.333 64.4667 285.6 36.6001 248.933C28.6001 238.4 27.9334 234.267 33.1334 228.133L36.6001 224H77.1334C99.4001 224 117.667 224.267 117.667 224.667C117.667 225.067 111 233.333 102.867 243.067C94.7334 252.8 87.1334 262.667 86.0667 265.2C83.6667 270.933 84.8667 276 89.8001 280.8C95.2667 286 103.8 286.267 109 281.333C115.933 274.8 153 229.2 154.867 224.933C155.933 222.4 156.333 218 155.933 214.267C155 204.4 148.333 196.933 138.2 194.667C135.267 193.867 110.867 193.733 82.3334 194.133L31.6667 194.8L23.2667 198.933C3.66674 208.267 -5.39993 234 4.06674 253.333C7.9334 261.333 60.3334 328.8 66.8667 334.267C87.2667 351.467 117.267 352.267 138.2 336.4C141.933 333.467 158.467 314.8 176.2 293.2C193.533 272.267 222.733 236.933 241 214.667C259.4 192.533 277.667 170.267 281.667 165.333C318.733 120 318.2 120.933 318.333 104.667C318.333 95.7334 317.667 92.6667 314.733 86.4001C310.067 76.4001 300.867 67.6001 291.533 64.1334C284.6 61.4667 281.667 61.3334 224.6 61.4667C191.8 61.4667 163.533 62.0001 161.667 62.5334Z",
    fill: "url(#paint1_linear_26_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6666 135.867C59 141.467 57.4 152.4 64.8666 168C67.5333 173.467 69.6666 179.067 69.6666 180.4C69.6666 182.533 70.7333 182.8 78.6 182.4L87.6666 182L88.4667 177.333C89 174.8 91.2666 169.067 93.5333 164.8C98.3333 155.6 98.7333 149.2 95 142.933C89.5333 134 78.8666 130.933 69.6666 135.867Z",
    fill: "url(#paint2_linear_26_5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.8 135.6C351.267 140.8 349.4 153.2 357 167.6C359.533 172.4 361.667 177.867 361.667 179.6C361.667 182.667 361.933 182.8 370.6 182.4C379.4 182 379.533 181.867 380.333 178C380.867 175.734 383.133 170.267 385.667 165.6C389.4 158.534 389.933 156.267 389.4 150.534C388.067 136.934 374.333 129.467 361.8 135.6Z",
    fill: "url(#paint3_linear_26_5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M310.067 194.534C297.4 197.734 289.933 210.534 293.533 222.8C294.6 226.4 302.733 237.2 318.333 256C338.867 280.534 342.2 284 346.333 284.8C351.533 285.734 357.533 283.734 361 280C364.467 276.134 365.133 267.467 362.2 263.067C360.333 260 342.067 237.467 332.6 226.267C330.733 224.134 332.6 224 371.267 224H411.933L415.533 227.467C417.933 230 419 232.4 419 235.867C419 240 415.8 244.667 394.333 272.667C380.733 290.267 366.867 307.2 363.667 310.134C357.133 316.267 348.6 319.2 341.4 317.734C330.867 315.734 327.8 312.8 296.2 274.667C279.267 254.134 263.8 236.134 261.933 234.667C251.4 226.267 235.533 238.267 239.8 251.2C240.467 253.067 255.533 272.267 273.4 293.867C307.8 335.467 312.467 340 327 344.934C337.4 348.4 355.8 348.134 365.667 344.267C379.133 338.934 384.867 333.2 415.267 294C446.333 254 448.733 249.867 448.733 236C448.733 219.734 439.4 205.067 424.6 197.734L417 194L365.667 193.734C337.4 193.6 312.333 194 310.067 194.534Z",
    fill: "url(#paint4_linear_26_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_5",
    x1: 244.533,
    y1: 46.0847,
    x2: 208.388,
    y2: 18.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394583,
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977437,
    stopColor: "#F42DE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_5",
    x1: 309.303,
    y1: 329.426,
    x2: 91.2644,
    y2: 88.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394583,
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977437,
    stopColor: "#F42DE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_5",
    x1: 96.4473,
    y1: 179.417,
    x2: 60.3472,
    y2: 152.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394583,
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977437,
    stopColor: "#F42DE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_5",
    x1: 388.519,
    y1: 179.417,
    x2: 352.381,
    y2: 152.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394583,
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977437,
    stopColor: "#F42DE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26_5",
    x1: 442.781,
    y1: 337.524,
    x2: 330.466,
    y2: 185.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394583,
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977437,
    stopColor: "#F42DE2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a24dfdfae2e1d09a7a756276b58350d7.svg";
export { ForwardRef as ReactComponent };